import gsap from 'gsap';

function homepageHeroAnimation () {
    const heroBanner = document.querySelector('.lanes-homepage-hero-banner'); 

    if (!heroBanner) {
        return;
    }

    const overlay = heroBanner.querySelector('.banner-overlay');
    const backgroundImage = heroBanner.querySelector('.background-image');
    const splatter = heroBanner.querySelector('.splatter');
    const image = heroBanner.querySelector('.homepage-banner-image');

    // Set initial state - only background image visible
    gsap.set([splatter, image], { opacity: 0 });
    gsap.set(splatter, { y: 100 });
    gsap.set(overlay, {opacity: 0.8});
    gsap.set(image, { y: 50, scale: 0.9 });
    gsap.set(backgroundImage, { y: 40, scale: 1.1 });

    const tl = gsap.timeline({ delay: 0.5 });

    tl.to(backgroundImage, {
        opacity: 1,
        y: 10,
        duration: 0.8,
        ease: "power1.out"
    })
    .to(splatter, {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: "power1.out"
    }, "<")
    .to(overlay, {
        opacity: 1,
        duration: 0.8,
        ease: "power1.out"
    }, "<")
    .to(image, {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 0.8,
        ease: "power2.out"
    }, "<");
}

// Initialize animation when DOM is ready
document.addEventListener('DOMContentLoaded', homepageHeroAnimation);
